import axios from "axios";
import config from "../../settings";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}

export const authAPI = {
  getToken: async (authenticationClientCode) => {
    try {
      const res = await axios.get(
        `${apiUrl}${process.env.REACT_APP_GET_ACCESS_TOKEN_ENDPOINT}${process.env.REACT_APP_GET_ACCESS_TOKEN_CODE}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            authenticationClientCode: authenticationClientCode,
          },
          timeout: 60000,
        }
      );
      console.log(res);
      return res;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
      throw error;
    }
  },
};
